export const PERMISSIONS = {
  FULL_ACCESS: {
    name: 'full_access',
    displayName: 'Acceso Completo',
    description: 'Permite acceso completo a todas las funcionalidades',
    tags: ['admin', 'superuser']
  },
  VIEW_ALL_TRAMITES_LIST: {
    name: 'tramites.view_all',
    displayName: 'Ver Todos los Trámites',
    description: 'Permite ver todos los trámites',
    tags: ['admin', 'superuser']
  },
  MANAGE_USERS: {
    name: 'users.manage',
    displayName: 'Gestionar Usuarios',
    description: 'Permite gestionar usuarios del sistema',
    tags: ['users', 'admin']
  },
  VIEW_USER_PASSWORD: {
    name: 'users.view_password',
    displayName: 'Ver Contraseñas de Usuarios',
    description: 'Permite ver la contraseña almacenada de los usuarios del sistema',
    tags: ['users', 'admin']
  },
  MANAGE_TRAMITES: {
    name: 'tramites.manage',
    displayName: 'Gestionar Trámites',
    description: 'Permite gestionar trámites',
    tags: ['tramites', 'tramites_tab']
  },
  FILTER_BY_DATE: {
    name: 'tramites.filter_by_date',
    displayName: 'Filtrar Trámites por Fecha',
    description: 'Permite aplicar filtros de fecha con valores predeterminados en la lista de trámites',
    tags: ['tramites', 'tramites_tab', 'filters']
  },
  VIEW_COMMENTS: {
    name: 'comments.view',
    displayName: 'Ver Comentarios',
    description: 'Permite ver comentarios en trámites',
    tags: ['comments', 'tramites_tab']
  },
  WRITE_COMMENTS: {
    name: 'comments.write',
    displayName: 'Escribir Comentarios',
    description: 'Permite escribir comentarios en trámites',
    tags: ['comments', 'tramites_tab']
  },
  MANAGE_COMMENTS: {
    name: 'comments.manage',
    displayName: 'Gestionar Comentarios',
    description: 'Permite gestionar comentarios en trámites',
    tags: ['comments', 'tramites_tab']
  },
  VIEW_DOCUMENTS: {
    name: 'documents.view',
    displayName: 'Ver Documentos',
    description: 'Permite ver documentos en trámites',
    tags: ['documents', 'tramites_tab']
  },
  UPLOAD_DOCUMENTS: {
    name: 'documents.upload',
    displayName: 'Subir Documentos',
    description: 'Permite subir documentos a trámites',
    tags: ['documents', 'tramites_tab']
  },
  MANAGE_DOCUMENTS: {
    name: 'documents.manage',
    displayName: 'Gestionar Documentos',
    description: 'Permite gestionar documentos en trámites',
    tags: ['documents', 'tramites_tab']
  },
  VIEW_STATUS_SUMMARY: {
    name: 'status_summary.view',
    displayName: 'Ver Resumen de Estado',
    description: 'Permite ver el resumen de estado de trámites',
    tags: ['status_summary', 'tramites_tab']
  },
  VIEW_TRAMITE_STATUS: {
    name: 'tramite_status.view',
    displayName: 'Ver Estado de Trámite',
    description: 'Permite ver el estado de trámites (solo lectura)',
    tags: ['tramites', 'tramites_tab']
  },
  VIEW_PLANOS_FILES: {
    name: 'planos_files.view',
    displayName: 'Ver Planos',
    description: 'Permite ver planos en trámites',
    tags: ['planos', 'tramites_tab']
  },
  VIEW_ESTUDIO_TITULO_FILES: {
    name: 'estudio_titulo_files.view',
    displayName: 'Ver Estudio de Título',
    description: 'Permite ver estudio de título en trámites',
    tags: ['estudio_titulo', 'tramites_tab']
  },
  VIEW_CERTIFICADOS_FILES: {
    name: 'certificados_files.view',
    displayName: 'Ver Certificados',
    description: 'Permite ver certificados en trámites',
    tags: ['certificados', 'tramites_tab']
  },
  UPLOAD_CERTIFICADOS_FILES: {
    name: 'certificados_files.upload',
    displayName: 'Subir Certificados',
    description: 'Permite subir certificados a trámites',
    tags: ['certificados', 'tramites_tab']
  },
  VIEW_TRAMITES_FILES: {
    name: 'tramites_files.view',
    displayName: 'Ver Trámites',
    description: 'Permite ver trámites',
    tags: ['subtramites', 'tramites_tab']
  },
  UPLOAD_FILES: {
    name: 'tramites.upload',
    displayName: 'Subir Archivos',
    description: 'Permite subir archivos a trámites',
    tags: ['tramites', 'tramites_tab']
  },
  MANAGE_AUTHORIZATION: {
    name: 'authorization.manage',
    displayName: 'Gestionar Roles',
    description: 'Permite gestionar roles y permisos del sistema',
    tags: ['roles', 'admin']
  },
  UPLOAD_PLANOS_FILES: {
    name: 'planos_files.upload',
    displayName: 'Subir Planos',
    description: 'Permite subir planos a trámites',
    tags: ['planos', 'tramites_tab']
  },
  UPLOAD_TRAMITES_FILES: {
    name: 'tramites_files.upload',
    displayName: 'Subir Archivos de Trámites',
    description: 'Permite subir archivos a trámites',
    tags: ['tramites', 'tramites_tab']
  },
  UPLOAD_ESTUDIO_TITULO_FILES: {
    name: 'estudio_titulo_files.upload',
    displayName: 'Subir Estudio de Título',
    description: 'Permite subir estudio de título a trámites',
    tags: ['estudio_titulo', 'tramites_tab']
  },
  UPLOAD_ESCRITURA: {
    name: 'escritura.upload',
    displayName: 'Subir Escritura',
    description: 'Permite subir escrituras a trámites',
    tags: ['escritura', 'tramites_tab']
  },
  SEND_WHATSAPP: {
    name: 'whatsapp.send',
    displayName: 'Enviar WhatsApp',
    description: 'Permite enviar notificaciones de WhatsApp',
    tags: ['whatsapp', 'tramites_tab']
  },
  VIEW_WHATSAPP_DISPATCHES: {
    name: 'whatsapp.dispatches.view',
    displayName: 'Ver Cola de WhatsApp',
    description: 'Permite ver la cola y detalle de despachos de WhatsApp',
    tags: ['whatsapp', 'tramites_tab']
  },
  MANAGE_WHATSAPP_TEMPLATES: {
    name: 'whatsapp.templates.manage',
    displayName: 'Gestionar Plantillas de WhatsApp',
    description: 'Permite crear, editar y activar plantillas de WhatsApp',
    tags: ['whatsapp', 'tramites_tab']
  },
  CREATE_TEMPORARY_LINKS: {
    name: 'temporary_links.create',
    displayName: 'Crear Enlaces Temporales',
    description: 'Permite crear enlaces temporales de descarga',
    tags: ['temporary_links', 'tramites_tab']
  },
  VIEW_TEMPORARY_LINKS: {
    name: 'temporary_links.view',
    displayName: 'Ver Enlaces Temporales',
    description: 'Permite ver enlaces temporales existentes',
    tags: ['temporary_links', 'tramites_tab']
  },
  DELETE_TEMPORARY_LINKS: {
    name: 'temporary_links.delete',
    displayName: 'Revocar Enlaces Temporales',
    description: 'Permite revocar enlaces temporales de descarga',
    tags: ['temporary_links', 'tramites_tab']
  },
  MANAGE_SYSTEM_CONFIGURATION: {
    name: 'system_configuration.manage',
    displayName: 'Gestionar Configuración del Sistema',
    description: 'Permite administrar configuraciones y parámetros del sistema',
    tags: ['admin', 'configuration']
  },
  VIEW_PRESUPUESTOS: {
    name: 'presupuestos.view',
    displayName: 'Ver Presupuestos',
    description: 'Permite ver presupuestos y sus cobros',
    tags: ['presupuestos', 'tramites_tab']
  },
  CREATE_PRESUPUESTOS: {
    name: 'presupuestos.create',
    displayName: 'Crear Presupuestos',
    description: 'Permite crear e iniciar presupuestos y registrar cobros',
    tags: ['presupuestos', 'tramites_tab']
  },
  EDIT_PRESUPUESTOS: {
    name: 'presupuestos.edit',
    displayName: 'Editar Presupuestos',
    description: 'Permite editar presupuestos y actualizar cobros',
    tags: ['presupuestos', 'tramites_tab']
  },
  DELETE_PRESUPUESTOS: {
    name: 'presupuestos.delete',
    displayName: 'Eliminar Presupuestos',
    description: 'Permite eliminar presupuestos, cobros y documentos',
    tags: ['presupuestos', 'tramites_tab']
  },
  VIEW_PRESUPUESTOS_FILES: {
    name: 'presupuestos_files.view',
    displayName: 'Ver Archivos de Presupuestos',
    description: 'Permite ver archivos de presupuestos en trámites',
    tags: ['presupuestos', 'tramites_tab']
  },
  UPLOAD_PRESUPUESTOS_FILES: {
    name: 'presupuestos_files.upload',
    displayName: 'Subir Archivos de Presupuestos',
    description: 'Permite subir archivos de presupuestos a trámites',
    tags: ['presupuestos', 'tramites_tab']
  },
  VIEW_COSTOS: {
    name: 'presupuesto-items.view',
    displayName: 'Ver Items de Presupuesto',
    description: 'Permite ver items de presupuesto de trámites',
    tags: ['presupuesto-items', 'tramites_tab']
  },
  CREATE_COSTOS: {
    name: 'presupuesto-items.create',
    displayName: 'Crear Items de Presupuesto',
    description: 'Permite crear items de presupuesto',
    tags: ['presupuesto-items', 'tramites_tab']
  },
  EDIT_COSTOS: {
    name: 'presupuesto-items.edit',
    displayName: 'Editar Items de Presupuesto',
    description: 'Permite editar items de presupuesto',
    tags: ['presupuesto-items', 'tramites_tab']
  },
  DELETE_COSTOS: {
    name: 'presupuesto-items.delete',
    displayName: 'Eliminar Items de Presupuesto',
    description: 'Permite eliminar items de presupuesto',
    tags: ['presupuesto-items', 'tramites_tab']
  },
  VIEW_PRESUPUESTOS_PROFORMA: {
    name: 'presupuestos-proforma.view',
    displayName: 'Ver Presupuestos Independientes',
    description: 'Permite ver los presupuestos creados sin escritura asociada',
    tags: ['presupuestos-proforma']
  },
  CREATE_PRESUPUESTOS_PROFORMA: {
    name: 'presupuestos-proforma.create',
    displayName: 'Crear Presupuestos Independientes',
    description: 'Permite crear presupuestos sin escritura asociada',
    tags: ['presupuestos-proforma']
  },
  EDIT_PRESUPUESTOS_PROFORMA: {
    name: 'presupuestos-proforma.edit',
    displayName: 'Editar Presupuestos Independientes',
    description: 'Permite editar presupuestos independientes y sus items',
    tags: ['presupuestos-proforma']
  },
  DELETE_PRESUPUESTOS_PROFORMA: {
    name: 'presupuestos-proforma.delete',
    displayName: 'Eliminar Presupuestos Independientes',
    description: 'Permite eliminar presupuestos independientes',
    tags: ['presupuestos-proforma']
  },
  CONFIRM_PRESUPUESTOS_PROFORMA: {
    name: 'presupuestos-proforma.confirm',
    displayName: 'Confirmar Presupuestos Independientes',
    description: 'Permite confirmar un presupuesto y volverlo a borrador',
    tags: ['presupuestos-proforma']
  },
  ARCHIVE_PRESUPUESTOS_PROFORMA: {
    name: 'presupuestos-proforma.archive',
    displayName: 'Archivar Presupuestos Independientes',
    description: 'Permite archivar presupuestos independientes',
    tags: ['presupuestos-proforma']
  },
  EXPORT_PRESUPUESTOS_PROFORMA: {
    name: 'presupuestos-proforma.export',
    displayName: 'Exportar Presupuestos',
    description: 'Permite exportar los documentos del adquiriente y del transferente',
    tags: ['presupuestos-proforma']
  },
  IMPORT_PRESUPUESTOS_PROFORMA: {
    name: 'presupuestos-proforma.import',
    displayName: 'Importar Presupuestos en Escrituras',
    description: 'Permite importar un presupuesto independiente dentro de una escritura',
    tags: ['presupuestos-proforma', 'tramites_tab']
  },
  MANAGE_PRESUPUESTOS_BASE: {
    name: 'presupuestos-base.manage',
    displayName: 'Administrar Items Predeterminados',
    description: 'Permite autogestionar la base de items predeterminados de cada parte',
    tags: ['presupuestos-proforma', 'admin']
  },
  VIEW_TRAMITE_TAREAS: {
    name: 'tramite-tareas.view',
    displayName: 'Ver Checklist de Tareas',
    description: 'Permite ver el checklist de tareas de una escritura',
    tags: ['tramite-tareas', 'tramites_tab']
  },
  MANAGE_TRAMITE_TAREAS: {
    name: 'tramite-tareas.manage',
    displayName: 'Gestionar Checklist de Tareas',
    description: 'Permite agregar, completar y eliminar tareas de una escritura',
    tags: ['tramite-tareas', 'tramites_tab']
  },
  MANAGE_TRAMITE_TAREAS_BASE: {
    name: 'tramite-tareas-base.manage',
    displayName: 'Administrar Tareas Predeterminadas',
    description: 'Permite autogestionar la base genérica de tareas del checklist',
    tags: ['tramite-tareas', 'admin']
  },
  MANAGE_BLOQUEO_TRAMITE: {
    name: 'tramites.bloquear',
    displayName: 'Bloquear Escritura',
    description: 'Permite marcar y desmarcar una escritura como bloqueada',
    tags: ['tramites', 'tramites_tab']
  },
  MANAGE_ARCHIVADO_TRAMITE: {
    name: 'tramites.archivar',
    displayName: 'Archivar Escrituras',
    description: 'Permite archivar y desarchivar escrituras, individualmente o en lote',
    tags: ['tramites', 'tramites_tab']
  },
  FINANCIAL_REPORTS: {
    name: 'financial.reports',
    displayName: 'Acceso al módulo de Contabilidad',
    description: 'Permite ver el módulo contable (resumen, movimientos, ingresos, egresos, utilidad, socios)',
    tags: ['contabilidad', 'admin']
  },
  CONTABILIDAD_VIEW: {
    name: 'contabilidad.view',
    displayName: 'Ver módulo de contabilidad',
    description: 'Permite ver el módulo de contabilidad',
    tags: ['contabilidad']
  },
  CONTABILIDAD_CREATE: {
    name: 'contabilidad.create',
    displayName: 'Crear movimientos y registrar pagos',
    description: 'Permite crear movimientos y registrar pagos en el módulo de contabilidad',
    tags: ['contabilidad']
  },
  CONTABILIDAD_EDIT: {
    name: 'contabilidad.edit',
    displayName: 'Editar movimientos y cajas',
    description: 'Permite editar movimientos y cajas en el módulo de contabilidad',
    tags: ['contabilidad']
  },
  CONTABILIDAD_DELETE: {
    name: 'contabilidad.delete',
    displayName: 'Eliminar movimientos y cajas',
    description: 'Permite eliminar movimientos y cajas en el módulo de contabilidad',
    tags: ['contabilidad']
  }
};
